// This is the Client-side UI Interface for the Identification screen, providing form validation.

const OfferResponseForm = require('common/models/form-offer-response')
const TermsAgreementForm = require('common/models/form-terms-agreement')
const FormValidation = require('client/js/helpers/form-validation')

// Timeout after Submit in seconds
const SUBMIT_TIMEOUT = 20

const $ = App.common.jQuery

class OffersUI {
   static doSubmit(action) {
      // Disable submit button for a bit to stop double-submits
      let subbtn = $('#offers-form').find('*[type="submit"]')
      let selbtn = $('#offers-form').find('button[name="offeractionbtn"][value="'+action+'"]')
      selbtn.addClass('continuing')
      subbtn.prop('disabled', true)
      setTimeout(()=> {
         subbtn.prop('disabled', false)
         selbtn.removeClass('continuing')
      }, SUBMIT_TIMEOUT * 1000)

      $('#offers-form').trigger('submit')
   }

   // Init is called when the page first loads.
   static init() {
      FormValidation.init('#offers-form', OfferResponseForm, (err, result) => {
         let formdata = $('#offers-form').serializeObject()
         // console.log('Offers validation', err, result, formdata)
         if (result) { // Invalid!
            return false;
         }
         else if (formdata.offeraction == 'accept') {
            // Have we agreed to the Terms?
            let termsdata = $('#terms-form').serializeObject()

            // Not International OR we've agreed to Terms & Decs...
            // if (formdata.type != 'INT' || (termsdata.agree_terms && termsdata.agree_declaration)) {
               // TODO: Check TISC Level selection for Domestic offers
               // OffersUI.doSubmit(formdata.offeraction)
            // IF International AND NOT agreed to Terms
            if (formdata.type == 'INT' && !(termsdata.agree_terms && termsdata.agree_declaration)) {
               // Reset validation
               $('#offers-form').removeClass("was-validated is-valid is-invalid")
               // Offer accept agreement popup/validation
               $('#acceptTsAndCsModal').modal('show');
               return false;
            // IF Domestic AND TISC selection is NOT selected (default "n/a" if not required)
            } else if (formdata.type != 'INT' && !(formdata.highested)) {
               // Reset validation
               $('#offers-form').removeClass("was-validated is-valid is-invalid")
               // Offer accept agreement popup/validation
               $('#HighestEdModal').modal('show');
               return false;
            }

            // Passed conditions and validations - submit the form
            OffersUI.doSubmit(formdata.offeraction)
         }
         else {
            OffersUI.doSubmit(formdata.offeraction)
         }
      })

      // Validation for the Terms & Declarations popup
      FormValidation.init('#terms-form', (err, result) => {
         let formdata = $('#terms-form').serializeObject()
         // console.log('Offers validation', err, result, formdata)
      })

      // Simplify radio button selection
      $('.offers-table').on('click', 'tr', function(e) {
         // console.log('Clicked select row', this)
         var rs = $(this);
         rs.find('input[type="radio"]').prop('checked', true)
         rs.find('input[type="radio"]').trigger('change')
         rs.siblings('.radio-select').removeClass('radio-selected')
         rs.addClass('radio-selected')
      })

      // FormValidation.init('#login_form', LoginForm, (err, result) => {
      //    let form = $('#login_form')
      //    let formdata = form.serializeObject()
      //    console.log(err, result, formdata)
      //    if (result) return; // Invalid!
      //    form.trigger('submit')
      // })

      // Use hidden field for offeraction - fixes double-clicks, etc...
      $('button[name=offeractionbtn]').on('click', function(ev) {
         // Copy selected button value to hidden field
         $('input:hidden[name=offeraction]').val($(this).val())
         console.log($(this).val(), $('input:hidden[name=offeraction]').val())
      })

      $('.defer-option button').on('click', function(ev) {
         var offer = $('input:radio[name=offerid]:checked').val() || $('input:hidden[name=offerid]').val()
         var title = $('input:radio[name=offerid]:checked').data('coursetitle')
         if (offer) {
            ev.preventDefault()
            if (title) {
               $('#offerlabel').html(title)
            }
            $('#defer-periods div.radio').hide()
            $('#defer-periods div[data-offer="'+offer+'"]').show()
            $('#defer-periods input[type="radio"]:first-child').attr('required','')
            $('#form-offers').collapse('hide')
            $('#form-offer-defer').collapse('show')
            $('#offers-title').hide('fast')
            $('#defer-title').show('fast')
            // TODO: $('form[data-toggle="validator"]').validator('update')
         }
      })

      // Confirmation dialog
      $('*[data-confirm]').on('click', function(ev) {
         var offer = $('input:radio[name=offerid]:checked').val() || $('input:hidden[name=offerid]').val()
         var title = $('input:radio[name=offerid]:checked').data('coursetitle') || $('input:hidden[name=coursetitle]').val()

         if (!offer) {
            // No offer? Just continue and let Validation handle the response
            return true;
         }

         var self = $(this);
         var href = $(this).attr('href');
         var confirmed = $(this).data('confirmed');
//         console.log('Confirmed: ',confirmed);
         if (confirmed)
            return true;
         if (!$('#dataConfirmModal').length) {
            $('body').append('');
         }
         let body = $(this).attr('data-confirm').replace(/COURSETITLE/, title || '')
         $('#dataConfirmModal').find('.modal-body').text(body)
         $('#dataConfirmOK').on('click', function(e) {
         //   console.log('Confirming & reclicking');
            self.data('confirmed','yes');
            $('#dataConfirmModal').modal('hide')
            self.trigger('click');
         });
         $('#dataConfirmModal').modal('show');
         ev.preventDefault();
         return false;
      });

      // Accept Conditions Modal
      $('#acceptTsAndCsConfirmOK').on('click', function(ev) {
         let formdata = $('#terms-form').serializeObject()
         // let form = new TermsAgreementForm(formdata)
         // form.validate((err, result) => {
         FormValidation.validate('#terms-form', TermsAgreementForm, (err, result) => {
            // console.log('Terms validation', err, result)
            if (result) return

            // Close the Modal
            // console.log('Closing the Modal')
            $('#acceptTsAndCsModal').modal('hide');

            // Update the "healthcare" field in the main form
            $('#offers-form input[name="healthcare"]').val(formdata.healthcare)

            // Resubmitting form
            // console.log('Clicking Accept again')
            OffersUI.doSubmit()
         })
      })

      // Confirm TISC Level Modal
      $('#HighestEdConfirmOK').on('click', function(ev) {
         // Get Highest Ed form response
         let formdata = $('#highested-form').serializeObject()
         if (!formdata.highested) {
            // Show error
            console.log('Highest Ed Level NOT selected')
            $('#highested-level-error').show()
            return
         } else {
            $('#highested-level-error').hide()
            console.log('Highest Ed Level selected:', formdata.highested)
            // Update the "highested" field in the main form
            $('#offers-form input[name="highested"]').val(formdata.highested)
            // Close the Modal
            $('#HighestEdModal').modal('hide');

            // Resubmitting form
            OffersUI.doSubmit()
         }
      })
   }

   // Update related info to selected course/offer when multiple offers are present
   static update_course(el, defer, condblock, istisc)
   {
      if (defer)
         $('.defer-option').collapse('show')
      else
         $('.defer-option').collapse('hide')

      $('.condblock-alert.show').collapse('hide')
      let offerid = $(el).val()
      if (condblock) {
         $('#offer-accept-button').prop('disabled', true)
         $(`.condblock-alert[offerid="${offerid}"]`).collapse('show')
      } else {
         $('#offer-accept-button').prop('disabled', false)
      }
      if (istisc) {
         $('#form-offers input[name="highested"]').prop('value', '')
      } else {
         $('#form-offers input[name="highested"]').prop('value', 'n/a')
      }
      console.log(`id=${offerid}, defer=${defer}, condblock=${condblock}, istisc=${istisc}, el=${el}, #condblock-${offerid}`, $(`.condblock-alert[offerid="${offerid}"]`))
   }
}

module.exports = OffersUI
